module.exports = __webpack_public_path__ + "static/media/home-1.8cf98538.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-1.jpg
// module id = ./src/assets/home-1.jpg
// module chunks = 0